import { useState } from "react";

export const ToggleSwitch = () => {
    const [isOn, setIsOn] = useState(false);
    return (
      <button
        onClick={() => setIsOn(!isOn)}
        className={`w-14 h-7 flex items-center rounded-full p-1 transition ${
          isOn ? "bg-green-500" : "bg-border-dark"
        }`}
      >
        <div
          className={`w-6 h-6 bg-white rounded-full shadow-md transform transition ${
            isOn ? "translate-x-6" : "translate-x-0"
          }`}
        />
      </button>
    );
  };
